import React, { useContext, useState } from "react";
import styles from "./styles/header.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { UserData } from "../../Context/DataContext";
import { useEffect } from "react";
import { useRef } from "react";
import { useEmployeeAuth } from "../Administrator/AdminProvider";
import warnImg from "./styles/img/warn.svg";
import { useAuth } from "../../Context/AuthContext";
import { GlobalOutlined } from "@ant-design/icons";

import { Button, Dropdown } from "antd";
// onboarding popups
import {
  handleNextClick,
  handleBackClick,
  handleCloseClick,
  resetIndex,
} from "../../Utils/onboardingButtons";
import { LanguageContext } from "../../Context/changeLanguageProvider";

import { formattingRedirectionUrl } from "../../Utils/redirectingUrl";
import { PartnerSwitcher } from "../User/PartnerNav/PartnerSwitcher";
import { PageTabs } from "../User/PartnerNav/PageTabs";
import {
  drawsOwnHeading,
  usePartnerView,
} from "../User/PartnerNav/partnerNav";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

export function Header({ selfrecovery, elements, showFreezed = true }) {
  const devEnv =
    window?.location?.host.includes("localhost") ||
    window?.location?.host.includes("127.0.0") ||
    window?.location?.host.includes("preprod");
  const auth = useAuth();
  const userData = UserData();
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  const [content, setContent] = useState(
    websiteCurrentLang.content.Header.header
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.Header.header);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  if (!elements && auth?.otp === true) {
    elements = [
      { text: "Dashboard", link: "/user/dashboard" },
      { text: "Asset Management", link: "/user/assetmanagement" },
      /*
        Its own entry in the band, as well as the crumb under the Asset
        Management heading.

        The crumb stays -- it is how the two views of one page read as a pair
        -- but it sits below the title in grey on white and was being missed.
        This is the only thing on the screen that says the page exists before
        you are already standing on its neighbour.

        The link is the Wealth Report view of Asset Management, which is what
        the crumb opens too, so both doors lead to the same room.

        Nested under Asset Management on purpose: the underline follows the
        LONGEST matching link, so this lights on its own page and leaves the
        parent lit everywhere else beneath it. See linkDepth below.

        One entry serves both headers -- the band and the burger menu are
        rendered from this same list (NavBar).
      */
      { text: "Wealth Report", link: "/user/assetmanagement/dashboard" },
      { text: "Beneficiaries", link: "/user/beneficiaries" },
      { text: "Trusted Advisors", link: "/user/advisors" },
      { text: "My Account", link: "/user/account" },
    ];
  }
  // onboarding popups
  // const onboardingCookie = Cookies.get('ostreon_onboarding_cookie');
  const authEmployee = useEmployeeAuth();
  const wrapperRefBoogle = useRef();
  const location = useLocation();
  /*
    A partner navigates by a strip below the page title instead of by this
    band, so the band shows them which context they are in. False for every
    other user and everywhere outside /user, which leaves the admin console,
    the beneficiary portal and the public site untouched.
  */
  const partnerView = usePartnerView();
  const wrapperRefAccount = useRef();
  const customer = UserData();
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);
  const [accountMenu, setAccountMenu] = useState(false);
  const { height, width } = useWindowDimensions();
  const status = customer?.isFreezed
    ? "INACTIVE"
    : customer?.CustomerUser?.user_status?.toUpperCase();
  let header_elements =
    elements &&
    elements.map((element) => {
      if (element.text === "Dashboard")
        return { ...element, text: dublicatedcontent.dublicatedText80 };
      else if (element.text === "Assets")
        return { ...element, text: dublicatedcontent.dublicatedText81 };
      else if (element.text === "Beneficiaries")
        return { ...element, text: dublicatedcontent.dublicatedText82 };
      else if (element.text === "My Account")
        return { ...element, text: dublicatedcontent.dublicatedText200 };
      else if (element.text === "Trusted Advisors")
        return {
          ...element,
          text: dublicatedcontent.dublicatedText26.replace("-", ""),
        };
      else if (element.text === "Asset Management")
        return { ...element, text: dublicatedcontent.dublicatedText282 };
      else if (element.text === "Wealth Report")
        return { ...element, text: dublicatedcontent.dublicatedText306 };
      else return element;
    });
  if (!header_elements) {
    header_elements = [
      {
        text: dublicatedcontent?.dublicatedText41,
        link: formattingRedirectionUrl(""),
      },
    ];
  }
  if (!authEmployee?.isAdmin)
    header_elements = header_elements.filter((e) => e.text !== "Users");
  const changeWebsiteLang = useContext(LanguageContext).changeWebsiteLanguage;

  const items = [
    {
      key: "1",
      label: (
        <div
          onClick={(e) => {
            changeWebsiteLang("fr");
          }}
          className={styles.languageWrapper}
          data-toggle="link"
        >
          <div data-toggle="link" className={styles.frenchLang}></div>
          <p data-toggle="link">French</p>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div
          data-toggle="link"
          onClick={(e) => {
            changeWebsiteLang("en");
          }}
          className={styles.languageWrapper}
        >
          <div data-toggle="link" className={styles.USALang}></div>
          <p data-toggle="link">English</p>
        </div>
      ),
    },
  ];

  /*
    Which tab is underlined.

    Matched on the tab's own `link` against the current path, not on its label:
    a page BELOW a tab keeps that tab lit, which the label could never do —
    /user/assetmanagement/dashboard ends in "dashboard" and so used to underline
    the Dashboard tab instead of Asset Management. It also stops depending on
    the label being English, which it is not once the site is in French.

    The longest matching link wins, so a tab nested under another still beats
    its parent, and the match has to end on a boundary — otherwise
    /user/assetmanagement would count as being inside /user/assets.
  */
  const pathname = location.pathname.replace(/\/+$/, "") || "/";
  const linkDepth = (link) => {
    if (!link || link === "/") return link === pathname ? 1 : 0;
    const base = link.replace(/\/+$/, "");
    if (pathname !== base && !pathname.startsWith(base + "/")) return 0;
    return base.length;
  };
  const activeLink = header_elements.reduce(
    (best, e) => (linkDepth(e.link) > linkDepth(best) ? e.link : best),
    null
  );

  let NavBar = [];
  header_elements.map((e) => {
    const selected =
      activeLink &&
      e.link === activeLink &&
      !window.location.pathname.includes("/beneficiary/home")
        ? styles.nav_element_selected
        : styles.nav_elements;
    /*
      This copy of My Account exists for the burger menu. On desktop the avatar
      block at the right of the band already offers it, so it is hidden there.

      It used to be hidden by position -- `.lower > div:nth-child(6)` -- which
      counted on the nav having exactly six items. Retiring the Assets tab shifted
      everything up one and that rule started hiding the avatar block instead.
      Marking the element says what is actually meant and survives the list
      changing again.
    */
    const className =
      e.link === "/user/account" ? `${selected} ${styles.nav_account}` : selected;
    NavBar.push(
      <div
        key={e.text.trim()}
        onClick={() => {
          if (auth?.otp === true) {
            navigate(e.link, { replace: true });
          } else {
            window.location.href = e.link;
          }
        }}
        data-toggle="link"
        className={className}
        style={{ zIndex: "0" }}
      >
        {e.text}
      </div>
    );
    return null;
  });

  useEffect(() => {
    if (openMenu) {
      document.body.classList.add("nav_opened");
    } else {
      document.body.classList.remove("nav_opened");
    }
  }, [openMenu]);
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      const parentElement = event.target.parentNode;

      if (event.target.getAttribute("data-toggle") === "link") {
        setTimeout(() => {
          setOpenMenu(false);
        }, 160);
      } else if (
        parentElement.parentNode.getAttribute("data-toggle") === "open" ||
        event.target.parentNode.getAttribute("data-toggle") === "open" ||
        event.target.getAttribute("data-toggle") === "open"
      ) {
        return;
      } else if (
        wrapperRefBoogle.current &&
        !wrapperRefBoogle.current.contains(event.target)
      ) {
        setOpenMenu(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRefBoogle]);
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (
        wrapperRefAccount.current &&
        !wrapperRefAccount.current.contains(event.target)
      ) {
        setAccountMenu(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRefAccount]);
  const getOnboard = (userData) => {
    navigate("/user/dashboard", { replace: true });
    resetIndex();
    setTimeout(() => {
      userData.setCustomerUser({
        ...userData.CustomerUser,
        first_login: true,
      });
    }, 500);
  };

  return (
    <>
      {customer?.isFreezed && showFreezed && (
        <div className={styles.freezed_header}>
          <div className={styles.freezed_header_top}>
            <img src={warnImg} alt="" />
            {content.headerText1}
          </div>
          <div>
            {content.headerText2}{" "}
            <span
              className={styles.link}
              onClick={() => navigate("/user/plan")}
            >
              {content.headerText3}
            </span>
          </div>
          <div>
            <span className={styles.only_desktop}>{content.headerText4}</span>
            {content.headerText5}
          </div>
        </div>
      )}
      <div
        className={
          /*
            The partner band carries its own layout and its own wave art. The
            extra class only ever lands on a partner's header, so every other
            header renders from exactly the rules it always did.
          */
          !partnerView
            ? styles.header
            : `${styles.header} ${styles.header_partner}`
        }
      >
        {/* {customer?.isFreezed && <div className={styles.freezed_header}>You are freezed</div>} */}
        {/* <div
        //   className={styles.help_link}
        //   onClick={() =>
        //     auth?.otp === true
        //       ? navigate("/user/Help-Center")
        //       : navigate("/Help-Center")
        //   }
        ></div> */}
        {width > 860 && (
          <Dropdown
            className={styles.dropdown}
            menu={{ items }}
            placement="bottom"
            arrow
            /*
              rc-dropdown defaults to ['hover'], so clicking the globe did
              nothing at all -- the menu only ever appeared if the pointer
              happened to rest on it. Hover is kept; click is what people try.
            */
            trigger={["click", "hover"]}
            overlayClassName={styles.y}
          >
            <div>
              <Button className={styles.lngButton}>
                <GlobalOutlined
                  style={{
                    margin: 0,
                    scale: "1.2",
                  }}
                />
                {websiteCurrentLang.label === "fr" ? (
                  <span
                    style={{
                      margin: 0,
                    }}
                  >
                    FR
                  </span>
                ) : (
                  <span
                    style={{
                      margin: 0,
                    }}
                  >
                    EN
                  </span>
                )}
              </Button>
            </div>
          </Dropdown>
        )}
        {(window.location.pathname.startsWith("/beneficiary/home") ||
          window.location.pathname.startsWith("/beneficiary/terms")) && (
          <div
            onClick={() => {
              navigate("/beneficiary/login", { replace: true });
            }}
            className={styles.beneficiary_logout}
          >
            {dublicatedcontent?.dublicatedText70}
          </div>
        )}
        {/* {(onboardingCookie !== '1' && customer) && */}
        {customer?.CustomerUser?.first_login &&
          window?.location.pathname === "/user/dashboard" && (
            <>
              <div className="hint_background"></div>
              <div
                className="hint_popup hint_popup_navigation up active"
                id="0"
              >
                <div className="hint_text">{content.headerText6}</div>
                <div className="hint_actions">
                  <button className="hint_btn hint_btn--back hint_btn-hidden">
                    {dublicatedcontent.dublicatedText71}
                  </button>
                  <div className="hint_counter">1/6</div>
                  <button
                    onClick={handleNextClick}
                    className="hint_btn hint_btn--next"
                  >
                    {dublicatedcontent.dublicatedText72}
                  </button>
                </div>
                <button
                  onClick={() => handleCloseClick(customer)}
                  className="close_hint_btn"
                ></button>
              </div>
              <div className="hint_popup hint_popup_status up" id="1">
                <div className="hint_text">{content.headerText7}</div>
                <div className="hint_actions">
                  <button
                    onClick={handleBackClick}
                    className="hint_btn hint_btn--back"
                  >
                    {dublicatedcontent.dublicatedText71}
                  </button>
                  <div className="hint_counter">2/6</div>
                  <button
                    onClick={handleNextClick}
                    className="hint_btn hint_btn--next"
                  >
                    {dublicatedcontent.dublicatedText72}
                  </button>
                </div>
                <button
                  onClick={() => handleCloseClick(customer)}
                  className="close_hint_btn"
                ></button>
              </div>
            </>
          )}

        <div className={styles.left}>
          <div
            onClick={() => navigate("/user/dashboard", { replace: true })}
            className={styles.ostreon_logo}
          ></div>
        </div>
        {header_elements.length > 0 && (
          <div
            ref={wrapperRefBoogle}
            onClick={(e) => setOpenMenu(!openMenu)}
            className={
              openMenu
                ? `${styles.boogle_menu} ${styles.boogle_opened}`
                : styles.boogle_menu
            }
          ></div>
        )}
        {openMenu && (
          <div className={styles.boogle_main_box}>
            {/*
              The ordinary links, for a partner too. The switcher is not one of
              these -- it chooses which account the links then apply to, and it
              stays in the band where it is always visible rather than behind a
              menu.
            */}
            {NavBar}

            <Dropdown
              className={styles.dropdownMobile}
              menu={{ items }}
              placement="bottom"
              arrow
              /* Tap opens it here too -- hover alone is no use on a phone. */
              trigger={["click", "hover"]}
            >
              <Button
                data-toggle="open"
                style={{
                  margin: "0",
                  padding: "0",
                }}
                className={`${styles.lngButton} lngButton`}
              >
                <div
                  data-toggle="open"
                  style={{
                    marginLeft: "0",
                    marginBottom: "20px",
                    position: "absolute",
                    width: "150px",
                    height: "22px",
                    top: "0",
                  }}
                />
                <GlobalOutlined
                  data-toggle="open"
                  style={{
                    margin: 0,
                    scale: "1.2",
                  }}
                />
                {websiteCurrentLang.label === "fr" ? (
                  <span
                    style={{
                      margin: 0,
                    }}
                  >
                    FR
                  </span>
                ) : (
                  <span
                    style={{
                      margin: 0,
                    }}
                  >
                    EN
                  </span>
                )}
              </Button>
            </Dropdown>

            <div
              onClick={() =>
                window.location.pathname.startsWith("/beneficiary")
                  ? navigate("/beneficiary/login", { replace: true })
                  : navigate("/logout", { replace: true })
              }
              data-toggle="link"
              className={styles.boogle_element}
              style={{
                marginTop: "10px",
              }}
            >
              {dublicatedcontent.dublicatedText70}
            </div>
          </div>
        )}
        <div
          style={{ display: selfrecovery ? "none" : "flex" }}
          className={styles.center}
        >
          <div className={styles.upper}>
            <div className={styles.digital_inheritance_text}>
              {customer ? content?.headerText8 : null}
            </div>
            <div
              onClick={() => {
                console.log("Cliking on blink");
                userData?.pushBlink(3000);
                navigate("/user/dashboard", {
                  replace: true,
                  state: { blink: true },
                });
              }}
              className={styles["status_button_" + status?.toLowerCase()]}
            >
              <span className={styles.status}>
                {dublicatedcontent[status?.toLowerCase()]?.toUpperCase()}
              </span>
            </div>
          </div>
          <div className={styles.lower}>
            {partnerView ? <PartnerSwitcher /> : NavBar}
            <div
              ref={wrapperRefAccount}
              className={styles.right}
              style={{ display: status ? "inline" : "none" }}
            >
              <div
                style={{
                  display: selfrecovery ? "none" : "flex",
                  position: "relative",
                  alignItems: "center",
                }}
              >
                <div
                  onClick={() => setAccountMenu(!accountMenu)}
                  className={styles.circle}
                >{`
                  ${customer?.UserData?.customer_name?.charAt(0)}${
                  customer?.UserData?.customer_last_name?.length > 0
                    ? customer?.UserData?.customer_last_name?.charAt(0)
                    : ""
                }`}</div>
                <div className={styles.account_div}>
                  <div
                    onClick={() => setAccountMenu(!accountMenu)}
                    className={styles.my_account}
                    style={{
                      width: "max-content",
                    }}
                  >
                    {content.headerLink2}
                  </div>
                  <div
                    onClick={() =>
                      auth?.otp === true
                        ? navigate("/user/help/center")
                        : navigate("/help/center")
                    }
                    className={styles.need_help}
                  >
                    {dublicatedcontent.dublicatedText40}
                  </div>
                </div>
                {accountMenu && (
                  <div
                    onClick={() => setAccountMenu(!accountMenu)}
                    className={styles.account_main_box}
                  >
                    <div
                      key={1}
                      onClick={() => {
                        navigate("/user/account");
                        customer.setMyAccount(1);
                      }}
                      className={styles.boogle_element}
                    >
                      {dublicatedcontent.dublicatedText77}
                    </div>
                    <div
                      key={2}
                      onClick={() => {
                        navigate("/user/account");
                        customer.setMyAccount(2);
                      }}
                      className={styles.boogle_element}
                    >
                      {content.headerLink5}
                    </div>

                    <div
                      key={3}
                      onClick={() => {
                        navigate("/user/account");
                        customer.setMyAccount(3);
                      }}
                      className={styles.boogle_element}
                    >
                      {content.headerLink6}
                    </div>
                    {customer?.CustomerUser?.user_type?.toLowerCase() ===
                      "customer" && (
                      <div
                        key={4}
                        onClick={() => {
                          navigate("/user/account");
                          customer.setMyAccount(4);
                        }}
                        className={styles.boogle_element}
                      >
                        {content?.headerLink7}
                      </div>
                    )}
                    {customer?.userValidationData?.status?.toLowerCase() ==
                      "active" &&
                      customer?.CustomerUser?.user_type?.toLowerCase() ===
                        "partner" && (
                        <div
                          key={4}
                          onClick={() => {
                            navigate("/user/account");
                            customer?.userValidationData?.type?.toLowerCase() ===
                            "influencer"
                              ? customer.setMyAccount(6)
                              : customer.setMyAccount(5);
                          }}
                          className={styles.boogle_element}
                        >
                          {/* {customer?.userValidationData?.type?.toLowerCase() ===
                          "influencer"
                            ? dublicatedcontent?.dublicatedText105
                            : dublicatedcontent?.dublicatedText104} */}
                          {dublicatedcontent?.dublicatedText104}
                        </div>
                      )}
                    <div
                      key={5}
                      onClick={() => getOnboard(customer)}
                      className={styles.boogle_element}
                    >
                      {content.headerLink8}
                    </div>
                    <div
                      key={6}
                      onClick={() => navigate("/logout", { replace: true })}
                      className={styles.boogle_element}
                    >
                      {dublicatedcontent.dublicatedText70}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*
        Pages listed in HEADING_PATHS draw the strip themselves, directly under
        their title, which is where the design puts it. This covers everywhere
        else under /user so a partner is never left with no way to navigate.
      */}
      {partnerView && !drawsOwnHeading(location.pathname) && (
        <PageTabs standalone />
      )}
    </>
  );
}
